<div id="wrapper">
<app-main-process [path]="path"></app-main-process>
<div id="main-content">
  <router-outlet (activate)="changeOfRoutes()" ></router-outlet>
  <!-- Dev version 0.0.4 url is {{BASE_URL}} -->
</div>
</div>